<template>
    <div class="page support container-fluid pt-3">
        <div class="box">
            <h1>{{ t('support-title') }}</h1>
            <p>
                {{ t('support-description') }}
            </p>
            <p>
                <strong>{{ t('support-service_hours_title') }}</strong> <br />
                <span>{{ t('support-service_hours_description') }}</span>
                <br />
            </p>

            <p>
                <a href="https://api.whatsapp.com/send/?phone=5548988418958" class="btn btn-primary tooltip-container"
                    target="_blank">
                    {{ t('support-whatsapp_button') }}

                    <!--          <span class="tooltip-content tooltip-center">-->
                    <!--            Indisponível durante o recesso-->
                    <!--          </span>-->
                </a>
                <a href="https://gokevi.notion.site/Central-de-Ajuda-5812ca0617604dfc9ef3da34d9727b87?pvs=4"
                    class="btn btn-primary" target="_blank">
                    {{ t('support-help_center_button') }}
                </a>
            </p>

            <h2>{{ t('support-emergency_title') }}</h2>
            <p>
                {{ t('support-emergency_description') }}
            </p>
            <p>
                <a href="https://kevi.io/suporte-plantao" class="btn btn-primary" target="_blank">
                    {{ t('support-emergency_button') }}
                </a>
            </p>
        </div>
    </div>
</template>
<style>
strong {
    font-weight: 500;
}

.line-through {
    text-decoration: line-through;
}
</style>
<script>
export default {
    name: "support",
    data() {
        return {
            msg: this.$root.t("support-title"),
        };
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
